"use strict";

import "./InputWithUnit.css";
import React from "react";
import Input from "./../Input";
import classnames from "classnames";

export default class InputWithUnit extends React.Component {
	
	getInputProps() {
		let inputProps = {};
		for (let key in this.props) {
			if (key == "className")
				continue;
			inputProps[key] = this.props[key];
		}
		return inputProps;
	}
	
	render() {
		return (
			<div className={classnames(this.props.className, "InputWithUnit")}>
				<div>
					<Input
						{...this.getInputProps()}
						type="number"
					/>
					<label>{this.props.label}</label>
				</div>
			</div>
		);
	}
	
}

InputWithUnit.propTypes = {
	label: React.PropTypes.string,
	typingTimeout: React.PropTypes.number,
	onTypeEnd: React.PropTypes.func
};

InputWithUnit.defaultProps = {
	label: "",
	typingTimeout: 1000
};


// WEBPACK FOOTER //
// ./~/vwa/components/InputWithUnit/InputWithUnit.jsx